import { apiPaths, handleError, queryKeys, validateStatus } from './config'
import { useQueryApi } from 'utils/api'

import type {
  ResponseSkpPsPeriodV2,
  ResponseSkpPsPeriodDetail,
} from 'types/kinerja-ps-pegawai'
import type { UseQueryOptions } from 'react-query'

export function useAPIGetPeriods(
  options?: UseQueryOptions<ResponseSkpPsPeriodV2>
) {
  return useQueryApi<ResponseSkpPsPeriodV2>(apiPaths.getPeriod, {
    queryKey: [queryKeys.API_GET_PERIODE],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: true,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}

export function useAPIGetPeriodDetail(
  id: string,
  options?: UseQueryOptions<ResponseSkpPsPeriodDetail>
) {
  return useQueryApi<ResponseSkpPsPeriodDetail>(`${apiPaths.getPeriod}/${id}`, {
    queryKey: [queryKeys.API_GET_PERIODE_DETAIL, id],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: false,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}
